export type HeroStat = {
    label: string;
    value: string;
};

export type HeroCta = {
    label: string;
    href: string;
};

export type HeroMock = {
    logoSrc: string;
    welcomeLabel: string;
    greeting: string;
    name: string;
    title: string;
    description: string;
    skills: string[];
    primaryCta: HeroCta;
    secondaryCta: HeroCta;
    stats: HeroStat[];
    floatIconIds: ('code' | 'terminal' | 'chip' | 'sparkles')[];
};

export const heroMock: HeroMock = {
    logoSrc: '/assets/logo/wihe_logo.png',
    welcomeLabel: 'Welcome to my portfolio',
    greeting: "Hi, I'm",
    name: 'Mykola',
    title: 'Full-Stack Developer',
    description:
        'Crafting innovative web solutions with modern technologies. Specialized in React, Next.js, Node.js, and creating seamless digital experiences.',
    skills: ['React', 'Next.js', 'Node.js', 'TypeScript'],
    primaryCta: { label: 'Explore my work', href: '#experience' },
    secondaryCta: { label: 'Get in touch', href: '#contact' },
    stats: [
        { label: 'Years Experience', value: '3+' },
        { label: 'Technologies', value: '15+' },
    ],
    floatIconIds: ['code', 'terminal', 'chip', 'sparkles'],
};
